import Leaflet from 'leaflet';

window.L = Leaflet;
